import React from 'react';
import { Box, Card, CardMedia, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet, clsx } from '@components/Provider';
import { ArrowForward } from '@material-ui/icons';

interface RequestProcessMethodCardProps {
  src: string;
  name: string;
  onClick: () => void;
  toBlog: (e: any) => void;
}

const RequestProcessMethodCard: React.FC<RequestProcessMethodCardProps> = ({
  src,
  name,
  onClick,
  toBlog
}) => {
  const { container, card, text, media, blogButton } = useStyles();

  return (
    <Box className={container}>
      <Card className={`${card} `} onClick={onClick} elevation={0}>
        <Box className={clsx([text, 'textBox'])}>
          <CustomizedTypography variant="body1" fontWeight="700">
            <i className="request-gtm-detailServiceType-btn">{name}</i>
          </CustomizedTypography>
        </Box>
        <CardMedia className={media} image={src} />
      </Card>
      {!name.includes('추천') && (
        <CustomizedButton
          className={blogButton}
          variant="text"
          color="primary"
          endIcon={<ArrowForward />}
          onClick={toBlog}
        >
          <CustomizedTypography
            variant="body2"
            fontWeight="500"
            color="primary"
          >
            {name}에 대해 알고 싶다면?
          </CustomizedTypography>
        </CustomizedButton>
      )}
    </Box>
  );
};

export default RequestProcessMethodCard;

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: 254,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '13px'
  },
  card: {
    boxSizing: 'border-box',
    width: 254,
    height: 196,
    borderRadius: 4,
    border: `1px solid ${colorSet.gray400}`,
    '&:hover': {
      border: `2px solid ${colorSet.primary500}`,
      cursor: 'pointer',
      '& .textBox': {
        padding: 11
      }
    }
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    padding: 12,
    height: 48
  },
  media: {
    height: 148
  },
  blogButton: {
    '& span > span': {
      marginLeft: 8,
      '& svg': {
        width: 16,
        height: 18
      }
    }
  }
}));
